import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as yup from "yup";
import { toast } from "react-toastify";
import {
  Button,
  Col,
  Form,
  Row,
  Stack,
  Container,
  Card,
  Spinner,
} from "react-bootstrap";
import InfoIcon from "../../../../assets/images/info-squar.svg";
import Swal from "sweetalert2";
import EditIcon from "../../../../assets/images/Edit-icon.svg";
import DeleteIcon from "../../../../assets/images/Delete-icon.svg";
import InspectionArrow from "../../../../assets/images/inspection-arrow.svg";
import { getDeficiencyMachineAPI } from "../../../../services/inspectionRequest";
import {
  getDeficiencyDataAPI,
  deleteDeficiencyApiCall,
  deficiencyCompleteAPI,
} from "../../../../services/deficiency";
import { InspectionData, DeficiencyInterface } from "./interface";
import moment from "moment";
import Recommendation from "./recommendation";
import ImageTag from "../../../../components/common/ImageTag";
import InputTextArea from "../../../../components/common/TextArea";
import { Formik } from "formik";
import InputText from "../../../../components/common/InputText";
import { nameBasedProtectedRoutes } from "../../../../router/protected";
import { MyContext } from "MyProvider";

export const UnsatisfactoryReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const [btnLoading, setBtnLoading] = useState(false);
  const deficiencyTitle = "deficiency";
  const recommendationTitle = "recommendation";
  const [loading, setLoading] = useState(true);
  const [showDeficiency, setShowDeficiency] = useState(false);
  const [changesState, setChangesState] = useState(false);
  const [deficiencyDataObject, setDeficiencyDataObject] = useState();
  const [deficiencyType, setDeficiencyType] = useState(deficiencyTitle);
  const [modelTitle, setModelTitle] = useState("Add Unsatisfactory");
  const [deficiencyListData, setDeficiencyListData] = useState<
    DeficiencyInterface[]
  >([]);
  const [recommendationListData, setRecommendationListData] = useState<
    DeficiencyInterface[]
  >([]);
  const [inspectionConfig, setInspectionConfig] =
    useState<InspectionData | null>(null);
  const { myState } = useContext(MyContext);

  const getDeficiencyData = () => {
    const params = {
      machine_id: state.machine_id,
      type: deficiencyTitle,
    };
    getDeficiencyDataAPI(params)
      .then((response) => {
        setDeficiencyListData(response);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const acknowledgementSchema = yup.object().shape({
    acknowledgement: yup
      .string()
      .required("acknowledgement is required")
      .min(1)
      .max(255),
  });

  const getRecommendationData = () => {
    const params = {
      machine_id: state.machine_id,
      type: recommendationTitle,
    };
    getDeficiencyDataAPI(params)
      .then((response) => {
        setRecommendationListData(response);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleSubmit = (values) => {
    deficiencyCompleteAPI(values)
      .then((response) => {
        setBtnLoading(false);
        toast.success(response.message);
        navigate(myState, { state: { travelPopup: true } });
      })
      .catch((error) => {
        setBtnLoading(false);
      });
  };

  const getDeficiencyMachineData = () => {
    const machine_id = state.machine_id;
    getDeficiencyMachineAPI(machine_id)
      .then((response) => {
        setLoading(false);
        setInspectionConfig(response);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleDelete = (id: number) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#FDB711",
      cancelButtonColor: "#dedede",
      color: "#000000",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteDeficiencyApiCall(id).then((response) => {
          Swal.fire("Deleted!", `${response.message}`, "success");
          setChangesState(!changesState);
        });
      }
    });
  };

  useEffect(() => {
    getDeficiencyMachineData();
    getDeficiencyData();
    getRecommendationData();
  }, [changesState]);

  const handleDeficiencyModel = (type: string) => {
    setDeficiencyType(type);
    setModelTitle("Add Our Recommendations");
    if (type == deficiencyTitle) {
      setModelTitle("Add Unsatisfactory");
    }

    setShowDeficiency(!showDeficiency);
  };

  const handleDeficiencyModelClose = () => {
    setShowDeficiency(!showDeficiency);
  };

  const editDeficiencyModel = (deficiency) => {
    setModelTitle("Edit Our Recommendations");
    if (deficiency.type == deficiencyTitle) {
      setModelTitle("Edit Unsatisfactory");
    }
    setDeficiencyDataObject(deficiency);
    setShowDeficiency(!showDeficiency);
  };
  const handleBack = () => {
    navigate(-1);
  };
  return (
    <section className="profile-main pt-4 inspector-bg ">
      <Recommendation
        showDeficiency={showDeficiency}
        handleDeficiencyModelClose={handleDeficiencyModelClose}
        machine_id={state.machine_id}
        deficiencyDataObject={deficiencyDataObject}
        setChangesState={setChangesState}
        changesState={changesState}
        type={deficiencyType}
        modelTitle={modelTitle}
      />
      <Container className="">
        <Row>
          <Col md={12} lg={12}>
            <h1 className="fs-16  mb-3 mt-2">
              <ImageTag src={InspectionArrow} className="inspection-arrow" />

              <span className="fw-bold">
                Recommendation/Unsatisfactory Report
              </span>
            </h1>
          </Col>
        </Row>
      </Container>
      <Container className="">
        <Row>
          <Col md={12} lg={12} className="">
            <Card className="border-0 mb-3">
              <Card.Body className="br-10 p-0 pt-2">
                <div className="col-xl-12">
                  <Row>
                    <Col md="3" className="mb-2">
                      <label className="fs-10 fw-bold">SR no.</label>
                      <div className="fs-13">
                        {inspectionConfig?.serial_number}
                      </div>
                    </Col>
                    <Col md="3" className="mb-2">
                      <label className="fs-10 fw-bold">Customer</label>
                      <div className="fs-13">
                        {" "}
                        {inspectionConfig?.user?.full_name}
                      </div>
                    </Col>
                    <Col md="3" className="mb-2">
                      <label className="fs-10 fw-bold">Inspection date</label>
                      <div className="fs-13">
                        {" "}
                        {moment(
                          inspectionConfig?.Inspection?.inspection_date
                        ).format("MM-DD-YYYY")}
                      </div>
                    </Col>
                    <Col md="3" className="mb-2">
                      <label className="fs-10 fw-bold">Inspector</label>
                      <div className="fs-13">
                        {inspectionConfig?.Inspection?.inspector?.full_name}
                      </div>
                    </Col>
                    <Col md="3" className="mb-2">
                      <label className="fs-10 fw-bold">Device ID</label>
                      <div className="fs-13">
                        {" "}
                        {inspectionConfig?.device_id ? inspectionConfig?.device_id :"-"}
                      </div>
                    </Col>
                    <Col md="3" className="mb-2">
                      <label className="fs-10 fw-bold">Make</label>
                      <div className="fs-13"> {inspectionConfig?.make}</div>
                    </Col>
                    <Col md="3" className="mb-2">
                      <label className="fs-10 fw-bold">Model</label>
                      <div className="fs-13">
                        {" "}
                        {inspectionConfig?.model_number}
                      </div>
                    </Col>
                    <Col md="3" className="mb-2">
                      <label className="fs-10 fw-bold">Serial</label>
                      <div className="fs-13">
                        {" "}
                        {inspectionConfig?.serial_number}
                      </div>
                    </Col>
                  </Row>
                </div>
                <hr className="border-10 bg-light mb-4"></hr>
                <div className="col-xl-12">
                  <Row className="mb-3">
                    <Col
                      md="12"
                      className="align-items-center d-flex justify-content-between"
                    >
                      <h2 className="fs-16 fw-bold border-left-6 mb-0 text-uppercase">
                        UNSATISFACTORY
                      </h2>
                      <Button
                        type="submit"
                        variant="primary"
                        onClick={() => {
                          handleDeficiencyModel(deficiencyTitle);
                        }}
                        className="btn btn-primary my-1 fw-semibold"
                      >
                        Add New
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <p className="d-flex align-items-start mb-3">
                        <ImageTag src={InfoIcon} className="me-2" />
                        <b>U &nbsp;</b> refers to an{" "}
                        <b> &nbsp;UNSATISFACTORY CONDITION </b>, which is any
                        issue found on the above-referenced device that we feel
                        should be corrected in a timely manner.
                      </p>

                      <div className="table-responsive">
                        <table className="table custome-table inspector-table">
                          <thead>
                            <tr>
                              <th>Unsatisfactory</th>
                              <th className="inspection-action">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {deficiencyListData.length > 0 ? (
                              deficiencyListData.map((deficiency, key) => {
                                return (
                                  <tr key={key}>
                                    <td>
                                      U{key + 1}- {deficiency.title}
                                    </td>
                                    <td>
                                      <span
                                        className="ms-1"
                                        onClick={() => {
                                          editDeficiencyModel({
                                            ...deficiency,
                                          });
                                        }}
                                      >
                                        <ImageTag
                                          src={EditIcon}
                                          alt={deficiency.title}
                                        />
                                      </span>
                                      <span
                                        onClick={() => {
                                          handleDelete(deficiency.id);
                                        }}
                                      >
                                        <ImageTag
                                          src={DeleteIcon}
                                          alt={deficiency.title}
                                        />
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={2} className="text-center">
                                  No Unsatisfactory Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  </Row>
                </div>
                <hr className="border-10 bg-light mb-4"></hr>
                <div className="col-xl-12">
                  <Row className="mb-3">
                    <Col
                      md="12"
                      className="align-items-center d-flex justify-content-between"
                    >
                      <h2 className="fs-16 fw-bold border-left-6 mb-0 text-uppercase">
                        OUR RECOMMENDATIONS
                      </h2>
                      <Button
                        type="submit"
                        variant="primary"
                        onClick={() => {
                          handleDeficiencyModel(recommendationTitle);
                        }}
                        className="btn btn-primary my-1 fw-semibold"
                      >
                        Add New
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <p className="d-flex align-items-start mb-3">
                        <ImageTag src={InfoIcon} className="me-2" />
                        <b>R &nbsp;</b>refers to{" "}
                        <b> &nbsp;Recommendations &nbsp;</b> relating to normal
                        maintenance that can extend the life of your device.
                      </p>
                      <div className="table-responsive">
                        <table className="table custome-table inspector-table">
                          <thead>
                            <tr>
                              <th>Recommendation</th>
                              <th className="inspection-action">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {recommendationListData.length > 0 ? (
                              recommendationListData.map(
                                (recommendation, key) => {
                                  return (
                                    <tr key={key}>
                                      <td>
                                        R{key + 1}- {recommendation.title}
                                      </td>
                                      <td>
                                        <span
                                          className="ms-1"
                                          onClick={() => {
                                            editDeficiencyModel({
                                              ...recommendation,
                                            });
                                          }}
                                        >
                                          <ImageTag
                                            src={EditIcon}
                                            alt={recommendation.title}
                                          />
                                        </span>
                                        <span
                                          onClick={() => {
                                            handleDelete(recommendation.id);
                                          }}
                                        >
                                          <ImageTag
                                            src={DeleteIcon}
                                            alt={recommendation.title}
                                          />
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            ) : (
                              <tr>
                                <td colSpan={2} className="text-center">
                                  No Recommendation Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  </Row>
                </div>
                <hr className="border-10 bg-light mb-4"></hr>
                <div className="col-xl-12">
                  <Row className="mb-3">
                    <Col
                      md="12"
                      className="align-items-center d-flex justify-content-between"
                    >
                      <h2 className="fs-16 fw-bold border-left-6 mb-0 text-uppercase">
                        acknowledgement
                      </h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Formik
                        validationSchema={acknowledgementSchema}
                        initialValues={{
                          acknowledgement:
                            "By signing this document, you and your witness are verifying that all of the above-mentioned (D) deficiencies have been resolved and that you acknowledge the (R) recommendation(s) our inspector(s) have made with respect to the above-listed device.",
                          machine_id: state.machine_id,
                        }}
                        onSubmit={handleSubmit}
                      >
                        {({
                          handleSubmit,
                          handleChange,
                          handleBlur,
                          values,
                          errors,
                          touched,
                          setFieldValue,
                        }) => (
                          <Form className="" noValidate onSubmit={handleSubmit}>
                            <InputTextArea
                              controlId="acknowledgement"
                              label="acknowledgement"
                              placeholder="acknowledgement"
                              touched={touched.acknowledgement}
                              handleBlur={handleBlur}
                              handleChange={handleChange}
                              errorsField={errors.acknowledgement}
                              value={values.acknowledgement}
                            />
                            <div className="d-flex justify-content-end inspector-footer pt-3 pb-3 pe-3 ps-3">
                              <Container>
                                <Row>
                                  <Col
                                    sm="12"
                                    className="d-flex justify-content-between"
                                  >
                                    <button
                                      type="reset"
                                      onClick={handleBack}
                                      className="me-2 fs-15 fw-semibold text-black btn btn-outline-secondary"
                                    >
                                      Back
                                    </button>
                                    {btnLoading ? (
                                      <button
                                        className="fs-15 fw-semibold text-black btn btn-primary"
                                        type="submit"
                                      >
                                        <Spinner size="sm" />
                                      </button>
                                    ) : (
                                      <button className="fs-15 fw-semibold text-black btn btn-primary">
                                        Submit
                                      </button>
                                    )}
                                  </Col>
                                </Row>
                              </Container>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
